<template>
  <v-fab
    v-if="canInstall"
    class="install-btn"
    color="secondary"
    size="small"
    icon="ri:download-cloud-line"
    @click="triggerInstall"
  />
</template>

<script setup lang="ts">
const { $pwa } = useNuxtApp();

const canInstall = computed(() => {
  return $pwa?.showInstallPrompt && !$pwa?.isPWAInstalled;
});

async function triggerInstall() {
  try {
    await $pwa?.install();
  } catch (err) {
    console.warn('PWA install failed or was cancelled:', err);
  }
}
</script>

<style lang="scss" scoped>
@keyframes full-rotate {
  0% {
    transform: rotate(0deg);
  }

  20% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.install-btn {
  position: fixed;
  z-index: 9999;
  right: 20px;
  bottom: 20px;

  transition: box-shadow 0.3s;
  animation: full-rotate 5s linear infinite;
}
</style>
